export const OUT_OF_STOCK = "OUT-OF-STOCK";
export const IN_STOCK = "AVAILABLE";
